import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'
import { formatDate } from '@atheneum/api/dist/lib'
import { capi, feeApi } from '@atheneum/api'
class RelatedInvoicesAndCreditNotes extends Component {
  static propTypes = {
    feeId: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props)
    extendObservable(this, {
      loading: false,
      error: null,
      invoicesAndCreditNotes: [],
      capiInvoice: null
    })

    this.renderInvoice = this.renderInvoice.bind(this)
  }

  async componentDidMount() {
    this.loading = true
    this.error = null
    try {
      const { feeId } = this.props
      await this.loadData(feeId)
      await this.getCapiInvoice()
    } catch (error) {
      this.error = error
    }
    this.loading = false
  }

  async getCapiInvoice() {
    const invoiceId = this.invoicesAndCreditNotes[0]?.id
    if (invoiceId) {

      this.capiInvoice = await capi.checkInvoice({
        invoiceId
      })
    }
  }


  loadData = async feeId => {
    const invoicesAndCreditNotes = await feeApi.getFeeInvoicesAndCreditNotes(feeId)
    this.invoicesAndCreditNotes.replace(invoicesAndCreditNotes)
  }

  renderInvoice(invoice) {
    const invoiceLabel = invoice.isCreditNote ? 'Credit note' : 'Invoice'
    const url = invoice.isPayg
      ? `/project/${invoice.projectId}/invoice/${invoice.id}`
      : `/contract/${invoice.contractId}/invoice/${invoice.id}`

    return (
      <div className='details-list' key={invoice.id}>
        <div>{invoiceLabel}:</div>
        <div>
          <Link to={url}>{invoice.name}</Link>{' '}
          {invoice.documentDate ? formatDate(invoice.documentDate) : ''}
          {this.capiInvoice?.call_only_invoice && ' (ENS call fee)'}
        </div>
      </div>
    )
  }

  render() {
    // no need to show the component until the info is loaded
    if (this.loading) return null

    let content

    if (this.error) {
      content = (
        <div className='text-error'>
          {this.error.message || `Couldn't fetch data, unknown error occurred.`}
        </div>
      )
    } else if (this.invoicesAndCreditNotes.length) {
      content = this.invoicesAndCreditNotes.map(this.renderInvoice)
    } else {
      content = (
        <div className='m-t-md m-b-md'>
          Not associated to the invoice or the credit note
        </div>
      )
    }

    return (
      <div>
        <h2>Invoicing</h2>
        {content}
      </div>
    )
  }
}

export default observer(RelatedInvoicesAndCreditNotes)
